module.exports = __webpack_public_path__ + "img/logo-lendingpad.2fa6e713.svg";